<template>
  <div class="seccion404 Timeout">

    <section id="servicios" class="secciones seccion-blanca">        
       <div class="container">
        <h1>Error: Excedió su tiempo de espera</h1>
        <div class="row">
         <div class="col-md-12">
           <p style="text-align: center;">Tiempo de espera excedido. Inténtelo Nuevamente.</p>
         </div>
        </div>
       </div>
    </section>

    <TwoModules></TwoModules>
    <Instagram></Instagram>

  </div>

</template>

<script>
import TwoModules from "@/components/products/TwoModules.vue";
import Instagram from "@/components/products/Instagram.vue";
import _ from "lodash";
import { errorToaster } from '@/components/shared/service/ErrorHandler';

export default {
  components: { TwoModules,
    Instagram },
  methods: {
    scroll_inicio(){
      window.scrollTo(0,0);
    },
  },
  created() {
    this.scroll_inicio();
  }
};
</script>

<style lang="scss" src="./Timeout.scss"></style>
